/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The source of the emission factor

Values: 0=Defra, 1=Ecoinvent, 2=Other
 * @export
 * @enum {number}
 */

export enum EmissionFactorSource {
    Defra = 0,
    Ecoinvent = 1,
    Other = 2
}


